import React, { useEffect, useState } from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import ValidationSchema from '../../helpers/ValidationSchema';
import RegisterFormBottom from './RegisterFormBottom';
import toggleRegisterForm from '../../store/actions/registerFormToggle';
import openEyeIcon from '../../assets/icons/eyeOpen.svg';
import closeEyeIcon from '../../assets/icons/eyeClose.svg';
import { registerRequest } from '../../store/actions/user';
import Spinner from '../Spinner';

function RegisterForm() {
  const lang = Cookies.get('i18next') || 'en';
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { signUpSchema } = ValidationSchema();
  const [registerLoading, setRegisterLoading] = useState(false);
  const { translations } = useSelector((state) => state.translation);
  const [checked, setChecked] = useState(false);
  const [openPassword, setOpenPassword] = useState(true);
  const [checkedError, setCheckedError] = useState(false);
  const [emailError, setEmailError] = useState('');
  const localBasket = useSelector((state) => state.basketReducers.localBasket);
  const handleRegister = async (formData) => {
    if (checked) {
      setRegisterLoading(true);
      const { payload } = await dispatch(registerRequest({ formData, localBasket, lang }));
      if (payload.status === 'error') {
        setEmailError(payload.messages.email);
        setRegisterLoading(false);
      } else {
        setRegisterLoading(false);
        dispatch(toggleRegisterForm({ visible: false, type: 'register' }));
        setEmailError('');
        window.location.replace(`/${lang}`);
        localStorage.removeItem('basket');
      }
    }
  };
  const handleOpenLoginModal = () => {
    dispatch(toggleRegisterForm({ visible: true, type: 'login' }));
  };
  useEffect(() => {
    if (checkedError) {
      if (checked) {
        setCheckedError(false);
      }
    }
  }, [checked]);
  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
        password_confirmation: '',
      }}
      onSubmit={async (values, actions) => {
        if (!checked) {
          setCheckedError(true);
        }
        await handleRegister({ ...values });
        actions.setSubmitting(false);
      }}
      validationSchema={signUpSchema}
    >
      <Form className="register-form">
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="email">{translations.email_label[lang]}</label>
          <div className="register-form-group_input input-block">
            <Field
              as="input"
              type="text"
              name="email"
              id="email"
              placeholder={translations.email_placeholder[lang]}
            />
          </div>
          <ErrorMessage
            name="email"
            component="p"
            className="authError"
          />
        </div>
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="password">{translations.password_label[lang]}</label>
          <div className="register-form-group_input input-block">
            <Field
              type={openPassword ? 'password' : 'text'}
              as="input"
              name="password"
              id="password"
              placeholder={translations.password_placeholder[lang]}
            />
            <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
              <img
                src={openPassword ? closeEyeIcon : openEyeIcon}
                alt="eye"
              />
            </button>
          </div>
          <ErrorMessage
            name="password"
            component="p"
            className="authError"
          />
        </div>
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="password_confirmation">{translations.confirm_password_label[lang]}</label>
          <div className="register-form-group_input input-block">
            <Field
              as="input"
              type={openPassword ? 'password' : 'text'}
              name="password_confirmation"
              id="password_confirmation"
              placeholder={translations.confirm_password_placeholder[lang]}
            />
            <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
              <img
                src={openPassword ? closeEyeIcon : openEyeIcon}
                alt="eye"
              />
            </button>
          </div>
          <ErrorMessage
            name="password_confirmation"
            component="p"
            className="authError"
          />
        </div>
        <RegisterFormBottom
          type="register"
          uniqueId="terms"
          checked={checked}
          setChecked={() => {
            setChecked(!checked);
          }}
        />
        {checkedError ? <p className="authError">{translations.required_field[lang]}</p> : null}
        <button type="submit" className="register-form-button">
          {
          registerLoading ? <Spinner isBtn size={20} /> : t('Sign Up')
        }
        </button>
        {emailError ? <p className="authError">{emailError}</p> : null}
        <div className="have-account">
          <p>
            {t('have-acc')}
            :
          </p>
          <button onClick={handleOpenLoginModal} type="button">{t('Login')}</button>
        </div>
      </Form>
    </Formik>
  );
}

export default RegisterForm;
